<template>
  <v-checkbox
    v-model="valueBooleanLocale"
    class="my-0 mb-2 mr-1"
    dense
    outlined
    hide-details
    return-object
    :label="label"
    :filled="filled"
    :disabled="disabled"
    :readonly="readonly"
    @change="$emit('input-changed', { value: $event })"
  >
    <template
      v-if="mostrarIcones"
      v-slot:prepend
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </template>
  </v-checkbox>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import ComponenteBase from './ComponenteBase.vue'
import Icons from './Icons.vue'
import checkableComponentMixin from '@/mixins/checkableComponentMixin'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  mixins: [checkableComponentMixin],

  setup(props) {
    const valueBooleanLocale = ref(props.valueBoolean)
    watchEffect(() => { valueBooleanLocale.value = props.valueBoolean })

    return {
      valueBooleanLocale,
    }
  },
}
</script>
